module.exports = __webpack_public_path__ + "assets/img/29006.png?f36490228104349d678016575fc6c2da";